module.exports = __webpack_public_path__ + "static/media/Butceler.6d530093.png";